import { PropsWithChildren } from "react";
import { PageWrapperProps } from "./components/props";
import usePageWrapperProps from "./selector/usePageWrapperProps";
import PageWrapperComponent from "./components/pageWrapper";

export default function PageWrapper(props: PropsWithChildren<{}>) {
	const viewProps: PageWrapperProps = usePageWrapperProps();
	return PageWrapperComponent({ ...props, ...viewProps });
}
